<nz-spin [nzSpinning]="loading">
    <div class="container quizzes-container">
        <div class="page-header">
            <div>
                <h2>User Provider Payplans</h2>
                <p class="page-subtitle">Review and maintain user provider pay plan details.</p>
            </div>
        </div>
          

        <nz-table #basicTable [nzData]="userPlans" [nzFrontPagination]="false" nzBordered>
            <thead>
                <tr>
                    <th>User</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Provider</th>
                    <th>Company</th>
                    <th>Start Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let plan of userPlans">
                    <td>{{ plan.user | titlecase }}</td>
                    <td>{{ plan.name }}</td>
                    <td>
                        <span class="status-tag" [ngClass]="plan.status">{{ plan.status | titlecase }}</span>
                    </td>
                    <td>{{ plan.provider }}</td>
                    <td>{{ plan.company }}</td>
                    <td>{{ plan.start_date | date: 'mediumDate' }}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>